export const eventConfig = {
  propertiesOrder: ['type', 'description', 'eventKey', 'default', 'example', 'enum'],
  excludedKeys: ['allOf', 'exclusiveMinimum', 'maximum', 'minimum', 'required'],
  skipKeys: ['allOf', 'items', 'oneOf', 'properties', 'propertiesMap'],
  dontWrapInPropertiesKeys: ['items'],
  specificExcludedValues: {
    items: { keys: ['description', 'type'] }
  },
  specificVisibleValues: {
    '': { keys: ['', 'properties', 'event'], nestIndexes: [0] },
    headers: { keys: ['properties'], nestIndexes: [0] },
    parameters: { keys: ['properties'], nestIndexes: [0] },
    success: { keys: ['properties'], nestIndexes: [0] }
  },
  specificSkipKeys: {
    '': { keys: ['', 'event'], nestIndexes: [0] },
    key: { keys: ['string'] }
  },
  specificDontWrapInPropertiesKeys: {
    key: { keys: ['string'] }
  },
  oneOfKeys: ['oneOf'],
  excludedEntryKeys: ['description', 'event', 'eventKey', 'type'],
  codeKeys: ['default', 'enum', 'example', 'eventKey', 'value'],
  colororizedKeys: ['type'],
  expandableFrom: 1,
  expandableTo: Infinity
};

export const endpointConfig = {
  propertiesOrder : ['type', 'description', 'eventKey', 'default', 'example', 'enum'],
  excludedKeys : ['allOf', 'exclusiveMinimum', 'maximum', 'minimum', 'required'],
  skipKeys : ['allOf', 'items', 'oneOf', 'properties', 'propertiesMap'],
  dontWrapInPropertiesKeys : ['items'],
  specificExcludedValues : {
    items: { keys: ['description', 'type'] }
  },
  specificVisibleValues : {
    headers: { keys: ['properties'], nestIndexes: [0] },
    parameters: { keys: ['properties'], nestIndexes: [0] },
    success: { keys: ['properties'], nestIndexes: [0] }
  },
  specificSkipKeys : {
    request: { keys: ['headers', 'parameters'], nestIndexes: [0] },
    response: { keys: ['success', 'errors'] , nestIndexes: [0] },
    key: { keys: ['string'] }
  },
  specificDontWrapInPropertiesKeys: {
    key: { keys: ['string'] }
  },
  excludedEntryKeys : ['description', 'type'],
  codeKeys : ['default', 'enum', 'example', 'eventKey', 'value'],
  colororizedKeys : ['type'],
  oneOfKeys : ['oneOf'],
  expandableFrom: 1,
  expandableTo: Infinity
};
